import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {CircleModel} from '../../../../models/api/circleModel';
import {useFetchCircles} from '../../../fetchers/circles';
import {SingleChoiceDropdown} from '../dropdowns/singleChoiceDropdown';
import {GenericSingleParameterProps} from './genericParameter';

/*
 * Props.
 */

interface CircleParameterProps extends GenericSingleParameterProps<CircleModel> {}

/*
 * Component.
 */

export const CircleParameter: FC<CircleParameterProps> = (props) => {
  const {selectedItem} = props;
  const {circles} = useFetchCircles();

  return (
    <SingleChoiceDropdown<CircleModel>
      items={circles ?? []}
      getItemKey={(item) => String(item.id)}
      onChange={props.onChange}
      renderItemLabel={(item) => item.name}
      renderItemIcon={() => <Icon name="teammates" />}
      selectedItem={selectedItem}
      serializeItemForSearch={(item) => item.name}
      placeholder={<Trans id="rule-editor-select-circle">Select a teammate group</Trans>}
    />
  );
};
